import React from 'react';

const MoneyTagIcon = ({ color = 'var(--icon-default)', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M3.93975 13.4468C2.65181 12.1588 2.00783 11.5148 1.76821 10.6793C1.52859 9.84382 1.73338 8.95643 2.14294 7.18164L2.37913 6.15816C2.7237 4.66502 2.89599 3.91845 3.40722 3.40722C3.91845 2.89599 4.66502 2.7237 6.15816 2.37913L7.18164 2.14294C8.95643 1.73338 9.84382 1.52859 10.6793 1.76821C11.5148 2.00783 12.1588 2.65181 13.4468 3.93975L14.9714 5.46445C17.2123 7.70527 18.3327 8.82568 18.3327 10.2179C18.3327 11.6102 17.2123 12.7306 14.9714 14.9714C12.7306 17.2123 11.6102 18.3327 10.2179 18.3327C8.82568 18.3327 7.70527 17.2123 5.46445 14.9714L3.93975 13.4468Z"
        stroke={color}
        strokeWidth="1.225"
      />
      <circle
        cx="7.17343"
        cy="7.40039"
        r="1.66667"
        transform="rotate(-45 7.17343 7.40039)"
        stroke={color}
        strokeWidth="1.225"
      />
      <path d="M9.61739 15.416L15.4332 9.59998" stroke={color} strokeWidth="1.225" strokeLinecap="round" />
    </svg>
  );
};

export default React.forwardRef(MoneyTagIcon);
